import {
  collection,
  onSnapshot,
  orderBy,
  query,
  where,
} from "firebase/firestore";

import { db } from "../firebase/firebase";

export function listenToActiveCategories(onSuccess, onError) {
  const categoriesQuery = query(
    collection(db, "categories"),
    where("isActive", "==", true),
    orderBy("displayOrder", "asc")
  );

  return onSnapshot(
    categoriesQuery,
    (snapshot) => {
      const categories = snapshot.docs.map((document) => {
        const data = document.data();
        return {
          id: document.id,
          ...data,
          image: data.websiteImage || data.image || "",
        };
      });

      onSuccess(categories);
    },
    onError
  );
}